<template>
    <div class="c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--red">
        <form action="" method="post" name="dafdirect" id="dafdirect" v-form-submit>
            <div class="row">
                <div class="col-md-12 form__image mb-3 d-flex justify-content-center align-items-center">
                    <img src="https://www.dafdirect.org/ddirect/images/logo-DAF-direct2.jpg" alt="Logo DAF Direct">
                </div>
                <div class="col-md-12 form__content">
                    <p>
                    If you have a donor advised fund, DAF Direct enables you to recommend grants to this nonprofit directly from your DAF (as long as your DAF's sponsoring organization is participating).
                </p>
                    <div class="form-group">
                        <label for="dafprovider">Donate now from: <span class="small text-danger">(required)</span></label>
                        <select class="form-control custom-select btn--select py-0" id="dafprovider" required>
                            <option value="">--Please select--</option>
                            <option value="FC">Fidelity Charitable</option>
                            <option value="SC">Schwab Charitable</option>
                            <option value="BNYM">BNY Mellon</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="dafdirect_dsgtxt">Designation:</label>
                        <input type="text" name="dafdirect_dsgtxt" id="dafdirect_dsgtxt" size="8" value="" class="dafdirectInputFull dafdirectInpu form-control" >
                    </div>

                    <div class="form-group">
                        <label for="dafdirect_amnt">Amount: $ <span class="small text-danger">(required)</span></label>
                        <input name="dafdirect_amnt" id="dafdirect_amnt" type="number" v-model.number="amount"  class="text-iput dafdirectInput form-control" required>
                    </div>

                    <!-- BUTTON -->
                    <button type="submit" @click.prevent="onSubmit" class="btn btn-round btn-primary btn-block">Submit</button>
                </div>  
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: {
        dafdirect_settings: {
            type: String,
            default: '135613797_1111_88885361-4ceb-423f-bde6-892d3785f35b'
        }
    },
    data() {
        return {
            dafdirect_tin: '',
            dafdirect_token: 'hello',
            amount: '',
            data_dafdirect_settings: ''

        }
    },
    methods: {
        generateToken: function() {
            this.dafdirect_token = this.dafdirect_settings.substring(15);
        },
        generateTin: function() {
            this.dafdirect_tin = this.dafdirect_settings.substring(0,9);
        },

        onSubmit: function() {
            let _dsgtxt = "";
            let _amnt="";
            let _dafurl="";
            let _npoid=this.dafdirect_tin;
            let _tokenstr = "";
            let _querystring = "";

            // DAF url
            if(document.getElementById("dafprovider") != "undefined" && "FC" == document.getElementById("dafprovider").value) {
                _dafurl="https://charitablegift.fidelity.com/cgfweb/CGFLogon.cgfdo";
            } else if("SC" == document.getElementById("dafprovider").value) {
                _dafurl="https://client.schwab.com/Login/SignOn/CustomerCenterLogin.aspx?SANC=recommendgrant&PARMS=|";
            } else if("BNYM" == document.getElementById("dafprovider").value) {
                _dafurl="https://bnym.iphiview.com/bnym/API/Grants.mvc.axd/DafDirect";
            } else {
                alert("Please select a donor advised fund.");
                return;
            }

            if(document.getElementById("dafdirect_dsgtxt")) {
                _dsgtxt = encodeURIComponent(document.getElementById("dafdirect_dsgtxt").value);
                document.getElementById("dafdirect_dsgtxt").value="";
            }
            if(document.getElementById("dafdirect_amnt")) {
                _amnt = document.getElementById("dafdirect_amnt").value.replace(/[^0-9\.]+/g, '');
                document.getElementById("dafdirect_amnt").value = "";
            }
            if("SC" == document.getElementById("dafprovider").value) {
                _tokenstr = "|ddtoken="+ this.dafdirect_token;
            } else {
                _tokenstr = "&ddtoken="+ this.dafdirect_token;
            }

            let action = "";
            if("SC" == document.getElementById("dafprovider").value) {
                _querystring = "Npo_Id=" + _npoid + "|Grnt_Amnt=" + _amnt + "|Device_Type=Widget|App_Id=MDNR|source=widget"+ "|Grnt_Dsg_Txt=" + _dsgtxt ;
                action = _dafurl + _querystring + _tokenstr;

            } else {
                _querystring="Npo_Id="+_npoid+"&Grnt_Amnt="+_amnt+"&Grnt_Dsg_Txt="+_dsgtxt+"&Device_Type=Widget&App_Id=MDNR&source=widget";
                action = _dafurl+"?"+_querystring+_tokenstr;
            }
            document.getElementById("dafprovider").value = "";
            let popupWindow = window.open(action,'_blank');
            popupWindow.focus();


            
        }
    },
    created() {
        if(this.dafdirect_settings === '' || this.dafdirect_settings === null) {
            this.data_dafdirect_settings =  this.$options.props.dafdirect_settings.default
        } else {
            this.data_dafdirect_settings = this.dafdirect_settings;
        }
        this.generateToken();
    }
 }
</script>
<style lang="scss" scoped>
form {
    label {
        font-weight: 500;
    }
}
p {
    font-size: 0.85rem;
    font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/app/components/aha-daf-widget.vue